<template style='margin: 0px;'>
  <div :style='{ height: editFlag ? tableEditorInfo.EditHeight === 0 ? "auto" : tableEditorInfo.EditHeight + "px" : tableEditorInfo.SaveHeight === 0 ? "auto" : tableEditorInfo.SaveHeight + "px",
    width: editFlag ? tableEditorInfo.EditWidth === 0 ? "auto" : tableEditorInfo.EditWidth + "px" : tableEditorInfo.SaveWidth === 0 ? "auto" : tableEditorInfo.SaveWidth + "px" }' class='main'>
    <div v-for='field in tableEditorFieldInfo' :key='field.FieldCode' class='oneFiled'>
      <div v-if='editFlag ? field.EditDisplay === "1" : field.SaveDisplay === "1"' class='oneFiled-left'
        :style='{ width: field.LabelWidth + "px",
          "text-align": field.LabelPosition === "0" ? "center" : field.LabelPosition === "1" ? "left" : "right",
          color: field.NotNull == "1" ? "blue" : "black" }'>
        {{field.FieldLabel}}
      </div>
      <div v-if='editFlag ? field.EditDisplay === "1" : field.SaveDisplay === "1"' class='oneFiled-right'
        :style='{ width: field.InputWidth + "px", "margin-right": field.MarginRight + "px" }'>
        <div v-if='field.CustomField === "0" && field.FieldType === "0"'>
          <el-input :placeholder='field.Placeholder' size='mini' v-model='tableEditorContent[field.FieldCode]'
            :disabled='editFlag ? field.EditDisabled === "1" ? true : false : field.SaveDisabled === "1" ? true : false'
            :readonly='editFlag ? field.EditReadOnly === "1" ? true : false : field.SaveReadOnly === "1" ? true : false'
            :style='{ width: field.InputWidth + "px"}'
            @keyup.enter.native='inputEnter(field.FieldCode)'
            @change='inputChange(field.FieldCode)'>
          </el-input>
        </div>

        <div v-if='field.CustomField === "0" && field.FieldType === "1"'>
          <el-input-number :placeholder='field.Placeholder' v-model='tableEditorContent[field.FieldCode]' size='mini' class='oneFiled-right'
            :disabled='editFlag ? field.EditDisabled === "1" ? true : false : field.SaveDisabled === "1" ? true : false'
            :readonly='editFlag ? field.EditReadOnly === "1" ? true : false : field.SaveReadOnly === "1" ? true : false'
            :max='field.MaxNumber || field.MaxNumber === 0 ? field.MaxNumber : 999999999999999999999999'
            :min='field.MinNumber || field.MinNumber === 0 ? field.MinNumber : -999999999999999999999999'
            :step='field.NumberStep ? field.NumberStep : 1'
            :style='{ width: field.InputWidth + "px"}'
            @keyup.enter.native='inputEnter(field.FieldCode)'
            @change='inputChange(field.FieldCode)'>
          </el-input-number>
        </div>

        <div v-if='field.CustomField === "0" && field.FieldType === "2"'>
          <el-select :placeholder='field.Placeholder'
            v-model='tableEditorContent[field.FieldCode]'
            size='mini' class='oneFiled-right'
            :disabled='editFlag ? field.EditDisabled === "1" ? true : false : field.SaveDisabled === "1" ? true : false'
            :style='"width:" + field.InputWidth + "px"'
            @keyup.enter.native='inputEnter(field.FieldCode)'
            @change='inputChange(field.FieldCode)'>
            <el-option v-for='selectData in getSpecialStringArrayInner(field.FieldCode)'
              :key='selectData.code'
              :label='selectData.name'
              :value='selectData.code'>
            </el-option>
          </el-select>
        </div>

        <div v-if='field.CustomField === "0" && field.FieldType === "3"'>
          <el-input :placeholder='field.Placeholder' v-model='tableEditorContent[field.FieldCode]' type='password' size='mini' class='oneFiled-right'
            :disabled='editFlag ? field.EditDisabled === "1" ? true : false : field.SaveDisabled === "1" ? true : false'
            :readonly='editFlag ? field.EditReadOnly === "1" ? true : false : field.SaveReadOnly === "1" ? true : false'
            :style='{ width: field.InputWidth + "px"}'
            @keyup.enter.native='inputEnter(field.FieldCode)'
            @change='inputChange(field.FieldCode)'>
          </el-input>
        </div>

        <div v-if='field.CustomField === "0" && field.FieldType === "4"'>
          <el-input :placeholder='field.Placeholder' type='textarea' v-model='tableEditorContent[field.FieldCode]' size='mini' class='oneFiled-right'
            :disabled='editFlag ? field.EditDisabled === "1" ? true : false : field.SaveDisabled === "1" ? true : false'
            :readonly='editFlag ? field.EditReadOnly === "1" ? true : false : field.SaveReadOnly === "1" ? true : false'
            :rows='field.NumberStep ? field.NumberStep : 10'
            :style='{ width: field.InputWidth + "px"}'
            @keyup.enter.native='inputEnter(field.FieldCode)'
            @change='inputChange(field.FieldCode)'>
          </el-input>
        </div>

        <div v-if='field.CustomField === "0" && field.FieldType === "5"'>
          <el-date-picker v-if='field.DateFormat.length === 4'
            :placeholder='field.Placeholder' type='year' v-model='tableEditorContent[field.FieldCode]'
            size='mini' class='oneFiled-right' :value-format='field.DateFormat'
            :disabled='editFlag ? field.EditDisabled === "1" ? true : false : field.SaveDisabled === "1" ? true : false'
            :readonly='editFlag ? field.EditReadOnly === "1" ? true : false : field.SaveReadOnly === "1" ? true : false'
            :style='{ width: field.InputWidth + "px"}' :format='field.DateFormat'
            @keyup.enter.native='inputEnter(field.FieldCode)'
            @change='inputChange(field.FieldCode)'>
          </el-date-picker>
          <el-date-picker v-if='field.DateFormat.length === 7'
            :placeholder='field.Placeholder' type='month' v-model='tableEditorContent[field.FieldCode]'
            size='mini' class='oneFiled-right' :value-format='field.DateFormat'
            :disabled='editFlag ? field.EditDisabled === "1" ? true : false : field.SaveDisabled === "1" ? true : false'
            :readonly='editFlag ? field.EditReadOnly === "1" ? true : false : field.SaveReadOnly === "1" ? true : false'
            :style='{ width: field.InputWidth + "px"}' :value='field.DateFormat'
            @keyup.enter.native='inputEnter(field.FieldCode)'
            @change='inputChange(field.FieldCode)'>
          </el-date-picker>
          <el-date-picker v-if='field.DateFormat.length === 10'
            :placeholder='field.Placeholder' type='date' v-model='tableEditorContent[field.FieldCode]'
            size='mini' class='oneFiled-right' :value-format='field.DateFormat'
            :disabled='editFlag ? field.EditDisabled === "1" ? true : false : field.SaveDisabled === "1" ? true : false'
            :readonly='editFlag ? field.EditReadOnly === "1" ? true : false : field.SaveReadOnly === "1" ? true : false'
            :style='{ width: field.InputWidth + "px"}' :value='field.DateFormat'
            @keyup.enter.native='inputEnter(field.FieldCode)'
            @change='inputChange(field.FieldCode)'>
          </el-date-picker>
          <el-date-picker v-if='field.DateFormat.length > 10'
            :placeholder='field.Placeholder' type='datetime' v-model='tableEditorContent[field.FieldCode]'
            size='mini' class='oneFiled-right' :value-format='field.DateFormat'
            :disabled='editFlag ? field.EditDisabled === "1" ? true : false : field.SaveDisabled === "1" ? true : false'
            :readonly='editFlag ? field.EditReadOnly === "1" ? true : false : field.SaveReadOnly === "1" ? true : false'
            :style='{ width: field.InputWidth + "px"}' :value='field.DateFormat'
            @keyup.enter.native='inputEnter(field.FieldCode)'
            @change='inputChange(field.FieldCode)'>
          </el-date-picker>
        </div>

        <div v-if='field.CustomField === "0" && field.FieldType === "6"'>
          <el-autocomplete :placeholder='field.Placeholder' size='mini' v-model='tableEditorContent[field.FieldCode]'
            :disabled='editFlag ? field.EditDisabled === "1" ? true : false : field.SaveDisabled === "1" ? true : false'
            :readonly='editFlag ? field.EditReadOnly === "1" ? true : false : field.SaveReadOnly === "1" ? true : false'
            :style='{ width: field.InputWidth + "px"}'
            :fetch-suggestions='((queryString, cb) => { querySearch(queryString, cb, field.FieldCode) })'
            @keyup.enter.native='inputEnter(field.FieldCode)'
            @select='inputChange(field.FieldCode)'
            @change='inputChange(field.FieldCode)'>
          </el-autocomplete>
        </div>

        <div v-if='field.CustomField === "1"'>
          <slot :name='"slot-" + field.FieldCode'></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import code from '@/components/sys/Code'

export default {
  name: 'TableEditor',
  components: {
  },
  props: {
    tableEditorInfo: {
      default: function () {
        return {}
      },
      type: Object
    },

    columnInfo: {
      default: function () {
        return []
      },
      type: Array
    },

    getSpecialStringArray: {
      default: function () {
        return {}
      },
      type: Function
    },

    tableEditorFieldInfo: {
      default: function () {
        return []
      },
      type: Array
    },

    tableEditorContent: {
      default: function () {
        return {}
      },
      type: Object
    },

    editFlag: {
      default: false,
      type: Boolean
    }
  },

  computed: {
    codes: function () {
      return this.$store.state.codes
    }
  },

  methods: {
    // 输入框回车事件
    inputEnter: function (fieldCode) {
      this.$emit('inputEnter', fieldCode)
    },

    // 输入框值改变事件
    inputChange: function (fieldCode) {
      this.$emit('inputChange', fieldCode)
    },

    getSpecialStringArrayInner: function (columnCode) {
      const that = this
      const arys = that.getSpecialStringArray(columnCode)
      if (arys && arys.length > 0) {
        return arys
      } else {
        for (let i = 0; i < that.columnInfo.length; i++) {
          if (that.columnInfo[i].ColumnCode === columnCode) {
            return code.getCode(that.codes, that.columnInfo[i].DateFormat)
          }
        }
      }
    },

    querySearch: function (queryString, cb, fieldCode) {
      const that = this
      const results = []
      const arrays = that.getSpecialStringArray(fieldCode)
      for (let i = 0; i < arrays.length; i++) {
        if (queryString === null || queryString === undefined || arrays[i].code.toUpperCase().indexOf(queryString.toUpperCase()) >= 0) {
          results.push({ value: arrays[i].code, name: arrays[i].name })
        }
      }
      cb(results)
    }
  }
}
</script>

<style scoped>
  .main{
    padding: 1px;
  }
  .oneFiled{
    padding-bottom: 10px;
    float: left;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
  }
  .oneFiled-left{
    font-size: 14px;
    color: #606266;
    vertical-align: center;
    line-height: 30px;
    padding: 0px 15px 0px 5px;
  }
  .oneFiled-right{
    margin: 0px;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    text-align: center;
  }
</style>
